import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { VAG_BRANDS } from '../../../seo/siteSeo';

export default function CompetenceSection() {
  return (
    <section className="spg-section spg-competence">
      <div className="spg-kicker">stop+go Partner</div>
      <h2 className="spg-title">Spezialist für VW, Audi, SEAT, Škoda &amp; CUPRA in Davos</h2>
      <p className="spg-lead">
        Die Sportplatzgarage Gutknecht ist Ihr stop+go Partner in Davos für Service,
        Diagnose und Reparaturen an Fahrzeugen des Volkswagen-Konzerns – mit Know-how,
        Originalteilen wo möglich und fairen Preisen.
      </p>

      <div className="spg-brand-links" style={{ marginTop: 28 }}>
        {VAG_BRANDS.map((brand) => (
          <RouterLink key={brand.slug} to={brand.path} className="spg-brand-chip">
            {brand.shortName}
          </RouterLink>
        ))}
      </div>

      <div className="spg-cta-row">
        <RouterLink className="spg-btn" to="/vag-garage-davos/">
          VAG-Garage Davos
        </RouterLink>
        <RouterLink className="spg-btn-outline" to="/dienstleistungen">
          Alle Dienstleistungen
        </RouterLink>
      </div>
    </section>
  );
}
